import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component";
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component";
import Title from "segments/desktop/core-components/title/title";
import WhatsNewMobileFirstFoldComponent from "./whats-new-mobile-first-fold/whats-new-mobile-first-fold-component";
import { createItemsArray } from "../utils";
import WhatsNewMobileSecondFoldComponent from "./whats-new-mobile-second-fold/whats-new-mobile-second-fold-component";
import WhatsNewPageItemsList from "../whats-new-items-list-component/whats-new-items-list";
import MobileFiltersComponent from "./mobile-filters/mobile-filters-component";
import FilterIcon from "/static/svg/filter.svg";
import { StyledWhatsNewPageLayoutMobileComponent } from "./whats-new-page-layout-mobile-component.scss";
const WhatsNewPageLayoutMobileComponent = (props)=>{
    var _mondayConfig_data_boards__items_page, _mondayConfig_data_boards_, _mondayConfig_data_boards, _mondayConfig_data;
    const { mondayConfig } = props;
    const items = mondayConfig === null || mondayConfig === void 0 ? void 0 : (_mondayConfig_data = mondayConfig.data) === null || _mondayConfig_data === void 0 ? void 0 : (_mondayConfig_data_boards = _mondayConfig_data.boards) === null || _mondayConfig_data_boards === void 0 ? void 0 : (_mondayConfig_data_boards_ = _mondayConfig_data_boards[0]) === null || _mondayConfig_data_boards_ === void 0 ? void 0 : (_mondayConfig_data_boards__items_page = _mondayConfig_data_boards_.items_page) === null || _mondayConfig_data_boards__items_page === void 0 ? void 0 : _mondayConfig_data_boards__items_page.items;
    const itemsArrayObj = createItemsArray(items);
    const itemsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.itemsArray) || [];
    const releaseHighlightsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.releaseHighlightsArray) || [];
    const [searchInput, setSearchInput] = useState("");
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [mobileFilterValues, setMobileFilterValues] = useState({});
    const [selectedFilterCount, setSelectedFilterCount] = useState(0);
    const itemsListRef = useRef(null);
    const [scrollToItemsList, setScrollToItemsList] = useState(false);
    const handleSearchInputChange = (e)=>{
        setSearchInput(e.target.value);
    };
    const handleFilterButtonClick = ()=>{
        setIsFilterModalOpen(true);
    };
    const closeModal = ()=>{
        setIsFilterModalOpen(false);
    };
    useEffect(()=>{
        if (scrollToItemsList) {
            const offsetTop = itemsListRef.current.offsetTop;
            const headerOffset = 200;
            window.scrollTo({
                top: offsetTop - headerOffset,
                behavior: "smooth"
            });
            setScrollToItemsList(false);
        }
    }, [
        scrollToItemsList,
        setScrollToItemsList
    ]);
    return /*#__PURE__*/ _jsxs(StyledWhatsNewPageLayoutMobileComponent, {
        className: `whats-new-mobile-page-component${isFilterModalOpen ? " no-scroll" : ""}`,
        children: [
            /*#__PURE__*/ _jsx(BaseHeaderComponent, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "whats-new-mobile-page-content",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "first-fold-wrapper",
                        children: /*#__PURE__*/ _jsx(WhatsNewMobileFirstFoldComponent, {
                            handleSearchInputChange: handleSearchInputChange
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "second-fold-wrapper",
                        children: /*#__PURE__*/ _jsx(WhatsNewMobileSecondFoldComponent, {
                            releaseHighlightsArray: releaseHighlightsArray
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "items-list-title-wrapper",
                        children: /*#__PURE__*/ _jsx(Title, {
                            title: "All Updates & Releases"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "filter-button-wrapper",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "filter-button",
                            onClick: handleFilterButtonClick,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "filter-icon-wrapper",
                                    children: /*#__PURE__*/ _jsx(FilterIcon, {})
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "filter-text",
                                    children: [
                                        " Filter ",
                                        selectedFilterCount > 0 && `(${selectedFilterCount})`
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "items-list-wrapper",
                        ref: itemsListRef,
                        children: /*#__PURE__*/ _jsx(WhatsNewPageItemsList, {
                            itemsArray: itemsArray,
                            textSearch: searchInput,
                            filterValues: mobileFilterValues,
                            isMobile: true
                        })
                    }),
                    /*#__PURE__*/ _jsx(MobileFiltersComponent, {
                        isOpen: isFilterModalOpen,
                        closeModal: closeModal,
                        setMobileFilterValues: setMobileFilterValues,
                        itemsArray: itemsArray,
                        setScrollToItemsList: setScrollToItemsList,
                        setSelectedFilterCount: setSelectedFilterCount
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LongFooterComponent, {})
        ]
    });
};
export default WhatsNewPageLayoutMobileComponent;
